/**
 * Translate for Chrome -Translator, Dictionary
 *
 * Exposes two WAR globs, `helpers/icons/*` and `popupView/*`, to `<all_urls>` with no
 * `use_dynamic_url` — so every icon and popup asset is fetchable from any page at a
 * stable URL. The `popupView/` tree carries vendor-specific paths (`csHelper.js`,
 * language data), and the icon set loads through `probeImage` with no CORS grant.
 *
 * Manifest verified against version 1.0.4.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'elpmkbbdldhoiggkjfpgibmjioncklbn';

export const translateForChrome: ExtensionDefinition = {
  id: ID,
  name: 'Translate for Chrome -Translator, Dictionary',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 500_000,
  notes:
    'Two WAR globs (helpers/icons/*, popupView/*) on <all_urls> with no dynamic URL. ' +
    'An icon loads without a CORS grant and the popupView paths corroborate; conclusive.',
  signals: [
    {
      id: 'war-icon-arrow-png',
      kind: 'web-accessible-resource',
      description:
        'Load helpers/icons/arrow.png via <img> — an icon exposed to every origin under ' +
        'the helpers/icons/ path; needs no CORS grant, so it survives a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'helpers/icons/arrow.png'),
    },
    {
      id: 'war-popup-cs-helper-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch popupView/js/csHelper.js — a vendor-specific script under the exposed ' +
        'popupView tree, an independent corroborating path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'popupView/js/csHelper.js'),
    },
    {
      id: 'war-popup-languages-json',
      kind: 'web-accessible-resource',
      description:
        'Fetch popupView/data/languagesData.json — the popup language table, a third ' +
        'independent path in the same exposed group.',
      weight: 0.5,
      run: () => probeFetch(ID, 'popupView/data/languagesData.json'),
    },
  ],
};
